var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiRecommendationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49463 11.0166H1.49463V19.0166H4.49463V11.0166Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49377 19.0166H13.3938C13.8487 19.0165 14.2901 18.8613 14.645 18.5766C14.9998 18.2919 15.247 17.8947 15.3458 17.4506L16.4568 12.4506C16.5218 12.1579 16.5203 11.8544 16.4522 11.5624C16.3841 11.2704 16.2512 10.9975 16.0634 10.7638C15.8756 10.5301 15.6377 10.3416 15.3672 10.2122C15.0967 10.0829 14.8006 10.0161 14.5008 10.0166H10.4938V6.0166C10.4938 5.48617 10.2831 4.97746 9.90799 4.60239C9.53291 4.22732 9.02421 4.0166 8.49377 4.0166L6.49377 10.0166",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9825 4.32599C18.1363 4.32599 16.64 5.82235 16.64 7.66858C16.64 5.82235 15.1436 4.32599 13.2974 4.32599C15.1436 4.32599 16.64 2.82962 16.64 0.983398C16.64 2.82962 18.1363 4.32599 19.9825 4.32599Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiRecommendationIcon);
export default __webpack_public_path__ + "static/media/aiRecommendationIcon.3d4322cf9a36638e47edb892159fa84c.svg";
export { ForwardRef as ReactComponent };